module.exports = __webpack_public_path__ + "static/img/9.58b243d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/9.png
// module id = GtLp
// module chunks = 2